export const education = [
  {
    school: "Savitribai Phule Pune University (S.B. Patil College of Engineering, Indapur)",
    degree: "Bachelor of Engineering, Electrical and Electronics Engineering",
    start: "2017",
    end: "2020",
    grade: "CGPA 5.9 (Second Class)",
    certificateUrl: "/documents/certificates/be-passing-certificate.jpg"
  },
  {
    school: "KBP College of Engineering, Satara",
    degree: "Diploma in Electrical Engineering, MSBTE (equivalent to HSC)",
    start: "2014",
    end: "2017",
    grade: "55.39% (Second Class)",
    certificateUrl: "/documents/certificates/diploma-marksheet.jpg"
  },
  {
    school: "MGV, Dahiwadi",
    degree: "SSC (10th), Maharashtra State Board",
    start: "2013",
    end: "2013",
    grade: "78.40%",
    certificateUrl: "/documents/certificates/ssc-marksheet.jpg"
  }
];
